import React, { useState, useCallback, useContext } from 'react';
import {
  AccessControl,
  Icon,
  NewTask,
  toast,
  ERROR_CODES,
  getTranslatedText
} from '@nile/components';
import DeleteModal from '@nile/projects/src/Components/Modals/DeleteModal';
import StatusHolder from '@nile/projects/src/Components/Elements/StatusHolder';
import { Button, Card, Heading, TextStyle } from '@shopify/polaris';
import { Popover } from '@superops/ui-design-system';
import { Stopwatch } from '@styled-icons/fa-solid';
import { MoreVert } from '@styled-icons/material';
import { constructTaskObject, renderTime } from '@nile/projects/src/Utils';
import { TicketClient, UPDATE_TASK, DELETE_TASK } from '@nile/graphql';
import { FormattedMessage, injectIntl } from 'react-intl';
import dompurify from 'dompurify';
import styled from 'styled-components';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';

const KanbanWrapper = styled.div`
  // width: 23vw;
  width: 375px;
  .ticket-task-card {
    max-height: 120px;
    height: 120px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
`;

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fx {
    .Polaris-Button--plain {
      padding: 0px !important;
      margin-left: 0px;
    }
  }
  .timer {
    display: flex;
    align-items: center;
  }
  .desc {
    font-size: 1.2rem;
    white-space: pre-wrap;
  }
  &.footer {
    .Polaris-TextStyle--variationStrong {
      font-size: 1.2rem;
    }
  }
  .options {
    .Polaris-Button--plain {
      color: #00000099;
      :hover {
        cursor: pointer;
      }
      svg {
        fill: #00000099;
      }
    }
  }
`;

const HeadingTag = styled.div`
  width: 50%;
  .Polaris-Button.Polaris-Button--plain {
    padding: 0px !important;
    margin-left: 0px !important;
    .Polaris-Button__Content {
      font-weight: bold;
      font-size: 1.6rem;
    }
  }
`;

const Field = styled.div`
  min-width: 152px;
  max-width: 160px;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
  .opt {
    justify-content: flex-start;
    .Polaris-Button.Polaris-Button--plain {
      padding: 0 10px !important;
      margin: -5px 0;
      justify-content: flex-start;
    }
    :hover {
      background-color: #ebebfa;
    }
  }
`;

const KanbanTaskCard = (props) => {
  const {
    title,
    description,
    status,
    techGroup,
    technician,
    estimatedTime,
    activeTab,
    intl
  } = props;

  const projectContext = useContext(ProjectContext);
  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };

  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = useCallback(
    () => setPopoverActive((val) => !val),
    []
  );

  const [active, setActive] = useState(false);

  const handleChange = useCallback(() => setActive(!active), [active]);

  const delModal = React.createRef();

  const updateTaskHandler = (type, task) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: { taskId: props.taskId, module: 'PROJECT', input: taskObj }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          props.setLanes(true);
          toast('success', 'Task updated successfully');
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const deleteTaskHandler = () => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: { taskId: props.taskId, module: 'PROJECT' }
    })
      .then((res) => {
        if (res?.data?.deleteTask) {
          props.setLanes(true);
          toast(
            'success',
            getTranslatedText(intl, 'ticket.details.task.delete.success')
          );
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const activator = (
    <Button
      onClick={togglePopoverActive}
      plain
      icon={
        <Icon
          style={{
            width: 20,
            height: 20,
            color: '#252739'
          }}
          icon={MoreVert}
        />
      }
    />
  );

  return (
    <KanbanWrapper {...props}>
      <Card customClassName="ticket-task-card">
        <OuterWrapper>
          {/* <Heading element="h4">{title}</Heading> */}
          <HeadingTag>
            <AccessControl
              reference={projectContext.features}
              roleToCheck="task.edit"
              render={
                <NewTask
                  addOrUpdateTechGroup={updateTaskHandler}
                  state={sheetActive}
                  toggleSheetActive={toggleSheetActive}
                  name={title}
                  hideIcon
                  isLink
                  data={props}
                  module="PROJECT_TASK"
                  details={
                    props?.taskId
                      ? {
                          operation: 'UPDATE',
                          projectId: props?.project?.projectId,
                          taskId: props?.taskId
                        }
                      : {
                          operation: 'CREATE',
                          projectId: props?.project?.projectId
                        }
                  }
                  onDeleteHandler={deleteTaskHandler}
                />
              }
              fallback={<div>{title}</div>}
            />
          </HeadingTag>

          <div className="fx actr">
            {activeTab !== 'tasks' && (
              <StatusHolder>{status || `Planned`}</StatusHolder>
            )}
            <AccessControl
              reference={projectContext.features}
              roleToCheck="task.delete"
              render={
                <div className="options" data-qa="taskOptions">
                  <Popover
                    active={popoverActive}
                    activator={activator}
                    onClose={togglePopoverActive}
                  >
                    <Field>
                      <div
                        data-qa="deleteKanbanTaskBtn"
                        className="opt full-width"
                      >
                        <Button
                          ref={delModal}
                          onClick={handleChange}
                          destructive
                          plain
                          fullWidth
                        >
                          <FormattedMessage id="projects.detail.kanban.tasks.delete" />
                        </Button>
                      </div>
                    </Field>
                  </Popover>
                </div>
              }
            />

            {/* <DeleteModal
              description="Are you sure you want to delete this task?"
              handleDeleteConfirmation={deleteTaskHandler}
              title="Delete task"
              destructive
              plain
            /> */}
          </div>
        </OuterWrapper>
        <OuterWrapper className="mt10 footer">
          <div className="timer">
            <Icon
              style={{
                width: 15,
                height: 15,
                color: '#00000066',
                marginRight: '6px'
              }}
              icon={Stopwatch}
            />
            <TextStyle variation="strong">
              {estimatedTime > 0 ? (
                renderTime(estimatedTime) || <div className="disabled">NA</div>
              ) : (
                <div className="disabled">NA</div>
              )}
            </TextStyle>
          </div>
          <div>
            {activeTab !== 'technician' && technician && (
              <TextStyle variation="strong">{`${technician.firstName} ${technician.lastName}`}</TextStyle>
            )}
          </div>
        </OuterWrapper>
      </Card>
      <DeleteModal
        description="Are you sure you want to delete this task"
        handleDeleteConfirmation={deleteTaskHandler}
        title="Delete task"
        reference={delModal}
        active={active}
        handleChange={handleChange}
      />
    </KanbanWrapper>
  );
};

export default injectIntl(KanbanTaskCard);
